import axios from "../../../util/axios";

export default {
    /** 批量查询职员的企业微信关联，用于职员列表回填「是否已关联企业微信」 */
    queryByEmployeeIds: (merchantId, employeeIds) =>
        axios.post({url: `/wx/merchant/employeeWx/queryByEmployeeIds`, data: {merchantId, employeeIds}}),
    /** 关联企业微信：把职员绑定到选中的企业微信用户 */
    bind: (employeeId, qywxUserId) =>
        axios.post({url: `/wx/merchant/employeeWx/bind?employeeId=${employeeId}&qywxUserId=${qywxUserId}`}),
    /**
     * 解除企业微信关联：关联错了先解除，之后才能重新关联到正确的企业微信用户。
     * 路径用 unbind 而不是 delete，避免命中拦截器「删除成功」的自动提示（这里提示文案不同）。
     */
    unbind: (employeeId) =>
        axios.post({url: `/wx/merchant/employeeWx/unbind?employeeId=${employeeId}`}),
}
